import React, { Component } from 'react';
import SelectBox from '../component/Select.js';
import Input from '../component/Input.js';
import Validation from './Validation.js';

export default class CurrentEdit extends Component {
	constructor(props){
		super(props);
		this.handleInput = this.handleInput.bind(this);
		this.removeVar = this.removeVar.bind(this);
		//this.setVariants = this.setVariants.bind(this);
		this.commitChanges = this.commitChanges.bind(this);
		//this.setNew = this.setNew.bind(this);
		//this.setCreate = this.setCreate.bind(this);
		this.state = {prize:'',tier:'',cap:'',picture:'',description:'',variants:[],prizeStatus:'',create:false,finish:false,new:false,invalid:false,invalidFields:''};
	}

	componentDidMount(){ //set state with current prize values so that inputs contain current values by default
		let p = this.props.prize;
		const cap = p.cap === null?'':p.cap;
		this.setState({prize:p.prize,tier:p.tier,cap:cap,picture:p.picture,description:p.description,variants:p.variants,prizeStatus:p.status});
	}

	handleInput(identity,value){ //standard method for handling user input
		const theState = this.state;
		theState[identity] = value;
		this.setState(theState);
	}

	// setNew(){ 
	// 	this.setState({new:true,create:false});
	// }

	// setVariants(variants){
	// 	this.setState(oldState => ({newVariants:[...oldState.newVariants,variants]}));
	// }

	// setCreate(){
	// 	this.setState({create:true});
	// }

	commitChanges(){ //method to begin process of updating prize info. eventually, all code in componentDidUpdate should be moved here
		this.setState({finish:true});
	}

	removeVar(identity,value){ //method for changing the status of a variant (active or inactive)
		let variants = this.state.variants;
		variants[identity].status = value;
		this.setState({variants:variants});
	}

	componentDidUpdate(prevProps,prevState){
		if(this.state.finish !== prevState.finish && this.state.finish){ //user has chosen to save all edited information
			const {tier,cap,picture,variants,newVariants,prizeStatus} = this.state;
			let prize = this.state.prize;
			let description = this.state.description;
			if(prize.trim() !== ''  && description.trim() !== '' && Validation("prize",prize.trim()) && Validation("prize",description.trim())){ //if all fields are filled out and contain valid input, continue
				let merge = [].concat.apply([],newVariants);
				this.props.onFinish({ID:this.props.prize.prizeID,prize:prize.trim(),tier:tier,cap:cap,picture:picture,description:description.trim(),variants:variants,newVariants:merge,status:prizeStatus}); //pass up state to EditPrize
			}else{ //log blank or invalid input fields
				let invalidField;
				if((!Validation("prize",prize.trim())||prize.trim() === '') && (!Validation("prize",description.trim())||description.trim() === '')){
					invalidField = 'both';
				}else if(!Validation("prize",prize.trim()) || prize.trim() === ''){
					invalidField = 'prize';
				}else if(!Validation("prize",description.trim()) || description.trim() === ''){
					invalidField = 'description';
				}
				this.setState({finish:false,invalid:true,invalidFields:invalidField});
			}	
		}
	}

	render(){
		const buttonStyles ="br3 white b w-30-ns w-60-m w-100 h2 bg-navy shadow-2";
		const inputStyles = "pt0 pb0 pr0 pl2 h2 br2 bw1 w-100 shadow-3";
		const selectStyles = "pa1 shadow-2 br2 b--gray bw1 mt2 w-70-ns";
		let areaStyles= inputStyles;
		let prizeStyles = inputStyles;
		let invalidMessage;
		let dis = false;
		if(this.state.invalid){ //error message and highlighting for invalid or empty input fields
			invalidMessage = <span className="b red">*All fields must be valid</span>;
			if(this.state.invalidFields === 'both'){
				areaStyles="pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";
				prizeStyles = "pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";
			}else if(this.state.invalidFields === 'prize'){
				prizeStyles = "pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";
			}else if(this.state.invalidFields === 'description'){
				areaStyles="pa0 h2 b--red br2 bw1 w-100 shadow-2 pl2";
			}
		}
		if(this.state.variants.length === 1){ //if only one variant exists, dont allow it to be set to inactive. whole prize should be set to inactive.
			dis = true;
		}
		const variants = this.state.variants.map((variants,i)=>{ //map out variants with dropdown menu to change status (active or inactive)
				const size = ((variants.size === null)||(variants.size === undefined)||(variants.size ===''))?"N/A":variants.size;
				const color = ((variants.color === null)||(variants.color === undefined)||(variants.color ===''))?"N/A":variants.color;
				return <li className="fl w-100 bb b--light-silver" key={i}><p className="fl w-33 tc">{size}</p><p className="fl w-33 tc">{color}</p><div className="fl w-33 tc"><SelectBox val={variants.status} identity={i} options={["active","inactive"]} onSelect={this.removeVar} styles={selectStyles} disable={dis}/></div></li>;
		});
		let photo;
		if(this.state.variants.length > 0){
		 photo = this.state.picture + this.state.variants[0].photo;
		}
		return(
			<div className="fl w-100" style={{margin:'auto'}}>
				{invalidMessage}
				<div className="fl w-100 mt2">
					<div className="fl w-50-ns w-100">
						<div className="fl w-100 pb1">
							<label className="b">Prize name: </label>
						</div>
						<div className="fl w-100 pr3">
							<Input identity="prize" onInput={this.handleInput} val={this.state.prize} inputStyle={prizeStyles}/>
						</div>
					</div>
					<div className="fl w-25-ns w-50 mt0-ns mt2">
						<div className="fl w-100 pb1">
							<label className="b">Tier: </label>
						</div>
						<div className="fl w-100 pr3">
							<SelectBox name="tier" identity="tier" onSelect={this.handleInput} options={this.props.tiers} styles={inputStyles} val={this.state.tier}/>
						</div>
					</div>
					<div className="fl w-25-ns w-50 mt0-ns mt2">
						<div className="fl w-100 pb1">
							<label className="b">Cap: </label>
						</div>
						<div className="fl w-100 pr3">
							<Input identity="cap" onInput={this.handleInput} val={this.state.cap} inputStyle={inputStyles} type="number"/>
						</div>
					</div>
				</div>
				<div className="fl w-100 mt4">
					<div className="fl w-75-ns w-100">
						<div className="fl w-100 pb1">
							<label className="b">Description: </label>
						</div>
						<div className="fl w-100 pr3">
							<Input identity="description" inputStyle={areaStyles} onInput={this.handleInput} val={this.state.description}/>
						</div>
					</div>
					<div className="fl w-25-ns w-100 mt0-ns mt2">
						<div className="fl w-100 pb1">
							<label className="b">Status: </label>
						</div>
						<div className="fl w-100 pr3">
							<SelectBox name="status" identity="prizeStatus" onSelect={this.handleInput} options={["active","inactive"]} styles={inputStyles} val={this.state.prizeStatus}/>
						</div>
					</div>
				</div>
				<div style={{maxHeight:'300px'}} className="fl w-100 mt3 overflow-y-scroll">
					<ul className="list fl w-100">
						{variants}
					</ul>
				</div>
				<div className="fl w-100 tc pt4">
					<button onClick={this.commitChanges} className={buttonStyles}>Save Changes</button>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/container/CurrentEdit.js